import { combineReducers } from '@reduxjs/toolkit';
import getDeviceBrandListReducer from './get-device-brand-list';
import getDeviceBrandListForSelectReducer from './get-device-brand-list-for-select';

const deviceBrandReducer = combineReducers({
  getDeviceBrandList: getDeviceBrandListReducer,
  getDeviceBrandListForSelect: getDeviceBrandListForSelectReducer
});

export default deviceBrandReducer;